<template>
	<div class="mt-4">
		<label class="text-body-2 font-weight-bold">入社日</label>
		<v-row class="mt-2" no-gutters>
			<v-col class="pr-1" sm="4">
				<v-combobox v-model="setYear" dense outlined :items="years" hide-details>
					<template v-slot:append-outer>年</template>
				</v-combobox>
			</v-col>
			<v-col class="px-1" sm="4">
				<v-combobox v-model="setMonth" dense outlined :items="months" hide-details>
					<template v-slot:append-outer>月</template>
				</v-combobox>
			</v-col>
			<v-col class="pl-1" sm="4">
				<v-combobox v-model="setDay" dense outlined :items="days" hide-details>
					<template v-slot:append-outer>日</template>
				</v-combobox>
			</v-col>
		</v-row>
		<div class="alternative-detail">
			<div class="v-messages">
				<template v-if="showDetail"> 年月日は全て入力しないと登録されません。 </template>
			</div>
		</div>
	</div>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		year: {
			type: null,
		},
		month: {
			type: null,
		},
		day: {
			type: null,
		},
	},
	data() {
		return {
			rules: rules,
		}
	},
	computed: {
		years() {
			const years = []
			for (let year = 1900; year <= new Date().getFullYear(); year++) {
				years.push(year)
				years.sort((a, b) => b - a)
			}
			return years
		},
		months() {
			const months = [...Array(12)].map((_, i) => i + 1)
			return months
		},
		days() {
			const days = [...Array(31)].map((_, i) => i + 1)
			return days
		},
		showDetail() {
			return (
				(this.setYear && (!this.setMonth || !this.setDay)) ||
				(this.setMonth && (!this.setYear || !this.setDay)) ||
				(this.setDay && (!this.setMonth || !this.setYear))
			)
		},
		setYear: {
			get() {
				return this.year
			},
			set(newValue) {
				return this.$emit("update:year", newValue)
			},
		},
		setMonth: {
			get() {
				return this.month
			},
			set(newValue) {
				return this.$emit("update:month", newValue)
			},
		},
		setDay: {
			get() {
				return this.day
			},
			set(newValue) {
				return this.$emit("update:day", newValue)
			},
		},
	},
}
</script>
